/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderVo
 */
export interface OrderVo {
    /**
     * 
     * @type {number}
     * @memberof OrderVo
     */
    id?: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof OrderVo
     */
    code?: string;
    /**
     * 用户id
     * @type {number}
     * @memberof OrderVo
     */
    userId?: number;
    /**
     * 结算方式 1 自动结算 2 手动结算
     * @type {number}
     * @memberof OrderVo
     */
    paymentType?: number;
    /**
     * 报关类型代码
     * @type {string}
     * @memberof OrderVo
     */
    ctmsCode?: string;
    /**
     * 出库计划日期
     * @type {string}
     * @memberof OrderVo
     */
    expectedOutboundDate?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof OrderVo
     */
    status?: number;
    /**
     * 客户端请求分组 0 海外直购，1 橙火入仓服务，2 3pl ，3 样品， 4 退货
     * @type {number}
     * @memberof OrderVo
     */
    requestGroup?: number;
    /**
     * 中国仓库备注
     * @type {string}
     * @memberof OrderVo
     */
    warehouseRemarkCn?: string;
    /**
     * 韩国仓库备注
     * @type {string}
     * @memberof OrderVo
     */
    warehouseRemarkKr?: string;
    /**
     * 订单类型
     * 海外直购-电商快递-代买服务  1
     * 海外直购-电商快递-转运服务  2
     * 海外直购-海运物流-代买服务  3
     * 海外直购-海运物流-转运服务 4
     * 橙火入仓服务-中国购入-代买服务 5
     * 橙火入仓服务-中国购入-转运服务 6
     * 橙火入仓服务-韩国购入-转运服务 7
     * 3PL-中国3PL入库-中国库存代买入库  8
     * 3PL-中国3PL入库-中国库存转运入库 9
     * 3PL-韩国3PL入库-中国购入转运入库 10
     * 3PL-韩国3PL入库-中国购入代买入库  11
     * 3PL-韩国3PL入库-韩国购入转运入库  12
     * 3PL-韩国3PL出库-韩国库存出库  13
     * 订单类型
     * @type {number}
     * @memberof OrderVo
     */
    orderType?: number;
    /**
     * 返送订单 处理方式 1废弃， 2韩国库存， 3 韩国快递件， 4 橙火入仓 一般快递，5 橙火入仓 官方揽收快递， 6橙火入仓 官方揽收托盘
     * @type {number}
     * @memberof OrderVo
     */
    returnFromCoupangMethod?: number;
    /**
     * 包装状态 0 未包装， 1 已包装， 2 不需要包装
     * @type {number}
     * @memberof OrderVo
     */
    packageStatus?: number;
    /**
     * 备注
     * @type {string}
     * @memberof OrderVo
     */
    remark?: string;
    /**
     * 管理员备注
     * @type {string}
     * @memberof OrderVo
     */
    adminRemark?: string;
    /**
     * 海关提单号
     * @type {string}
     * @memberof OrderVo
     */
    blNo?: string;
    /**
     * 申请类别  0 海外直购，1 官方揽收快递，2 官方揽收托盘，3 一般快递，4 韩国3PL，5 中国3PL，6 韩国库存出库 7 样品
     * @type {number}
     * @memberof OrderVo
     */
    requestType?: number;
    /**
     * 是否装箱保存，0 不装，1 装纸箱， 2 装托盘
     * @type {number}
     * @memberof OrderVo
     */
    packingStorage?: number;
    /**
     * 是否为清关列表 0 不是， 1 是  默认0
     * @type {number}
     * @memberof OrderVo
     */
    listCtms?: number;
    /**
     * 仓库要求 原CENTER_REQ_CONT
     * @type {string}
     * @memberof OrderVo
     */
    warehouseRequest?: string;
    /**
     * 商品总数
     * @type {number}
     * @memberof OrderVo
     */
    goodsTotalQuantity?: number;
    /**
     * 商品总金额
     * @type {number}
     * @memberof OrderVo
     */
    goodsTotalAmount?: number;
    /**
     * 商品总金额  美元
     * @type {number}
     * @memberof OrderVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof OrderVo
     */
    enable?: number;
    /**
     * 是否删除 0 未删除，1 已删除
     * @type {number}
     * @memberof OrderVo
     */
    deleteStatus?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof OrderVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof OrderVo
     */
    updateTime?: string;
    /**
     * 优惠券id，下单的时候，可以选择是否使用优惠券
     * @type {number}
     * @memberof OrderVo
     */
    prepayCouponId?: number;
    /**
     * 是否因商品检查有误，客户申请了退货 0 不是， 1 是。注意，这里和商品售卖后买家发起退货是两回事
     * @type {number}
     * @memberof OrderVo
     */
    wrongOrderReturn?: number;
    /**
     * 下单仓库id
     * @type {number}
     * @memberof OrderVo
     */
    orderWarehouseId?: number;
    /**
     * 商品验收前确认要求项
     * @type {string}
     * @memberof OrderVo
     */
    requireBeforeAccept?: string;
    /**
     * 当前仓库id
     * @type {number}
     * @memberof OrderVo
     */
    currentWarehouseId?: number;
    /**
     * 报关类型 1 企业清关 2 个人清关 3 护照清关
     * @type {number}
     * @memberof OrderVo
     */
    ctmsType?: number;
    /**
     * 如果当前订单是退货订单，这里记录要退货的订单id
     * @type {number}
     * @memberof OrderVo
     */
    returnOrderId?: number;
    /**
     * coupang入库码
     * @type {string}
     * @memberof OrderVo
     */
    coupangInboundCode?: string;
    /**
     * 商品总金额  人民币
     * @type {number}
     * @memberof OrderVo
     */
    goodsTotalAmountCny?: number;
    /**
     * coupang入库时间
     * @type {string}
     * @memberof OrderVo
     */
    coupangInboundDate?: string;
    /**
     * coupang公司名称
     * @type {string}
     * @memberof OrderVo
     */
    coupangCompanyName?: string;
    /**
     * 1 代买服务 2 转运服务
     * @type {number}
     * @memberof OrderVo
     */
    buyType?: number;
    /**
     * 退货方式 1 退货标签(附件）2 退货标签（箱内附带）3 退货申请编号 4 使用中心快递
     * @type {number}
     * @memberof OrderVo
     */
    returnMethod?: number;
    /**
     * 退货标签文件
     * @type {string}
     * @memberof OrderVo
     */
    returnFlagFile?: string;
    /**
     * 分裂出去的订单id
     * @type {Array<number>}
     * @memberof OrderVo
     */
    splitOrderIds?: Array<number>;
}

/**
 * Check if a given object implements the OrderVo interface.
 */
export function instanceOfOrderVo(value: object): value is OrderVo {
    return true;
}

export function OrderVoFromJSON(json: any): OrderVo {
    return OrderVoFromJSONTyped(json, false);
}

export function OrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'ctmsCode': json['ctmsCode'] == null ? undefined : json['ctmsCode'],
        'expectedOutboundDate': json['expectedOutboundDate'] == null ? undefined : json['expectedOutboundDate'],
        'status': json['status'] == null ? undefined : json['status'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'warehouseRemarkCn': json['warehouseRemarkCn'] == null ? undefined : json['warehouseRemarkCn'],
        'warehouseRemarkKr': json['warehouseRemarkKr'] == null ? undefined : json['warehouseRemarkKr'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'returnFromCoupangMethod': json['returnFromCoupangMethod'] == null ? undefined : json['returnFromCoupangMethod'],
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'adminRemark': json['adminRemark'] == null ? undefined : json['adminRemark'],
        'blNo': json['blNo'] == null ? undefined : json['blNo'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'packingStorage': json['packingStorage'] == null ? undefined : json['packingStorage'],
        'listCtms': json['listCtms'] == null ? undefined : json['listCtms'],
        'warehouseRequest': json['warehouseRequest'] == null ? undefined : json['warehouseRequest'],
        'goodsTotalQuantity': json['goodsTotalQuantity'] == null ? undefined : json['goodsTotalQuantity'],
        'goodsTotalAmount': json['goodsTotalAmount'] == null ? undefined : json['goodsTotalAmount'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'prepayCouponId': json['prepayCouponId'] == null ? undefined : json['prepayCouponId'],
        'wrongOrderReturn': json['wrongOrderReturn'] == null ? undefined : json['wrongOrderReturn'],
        'orderWarehouseId': json['orderWarehouseId'] == null ? undefined : json['orderWarehouseId'],
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
        'currentWarehouseId': json['currentWarehouseId'] == null ? undefined : json['currentWarehouseId'],
        'ctmsType': json['ctmsType'] == null ? undefined : json['ctmsType'],
        'returnOrderId': json['returnOrderId'] == null ? undefined : json['returnOrderId'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'goodsTotalAmountCny': json['goodsTotalAmountCny'] == null ? undefined : json['goodsTotalAmountCny'],
        'coupangInboundDate': json['coupangInboundDate'] == null ? undefined : json['coupangInboundDate'],
        'coupangCompanyName': json['coupangCompanyName'] == null ? undefined : json['coupangCompanyName'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
        'returnMethod': json['returnMethod'] == null ? undefined : json['returnMethod'],
        'returnFlagFile': json['returnFlagFile'] == null ? undefined : json['returnFlagFile'],
        'splitOrderIds': json['splitOrderIds'] == null ? undefined : json['splitOrderIds'],
    };
}

export function OrderVoToJSON(json: any): OrderVo {
    return OrderVoToJSONTyped(json, false);
}

export function OrderVoToJSONTyped(value?: OrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'userId': value['userId'],
        'paymentType': value['paymentType'],
        'ctmsCode': value['ctmsCode'],
        'expectedOutboundDate': value['expectedOutboundDate'],
        'status': value['status'],
        'requestGroup': value['requestGroup'],
        'warehouseRemarkCn': value['warehouseRemarkCn'],
        'warehouseRemarkKr': value['warehouseRemarkKr'],
        'orderType': value['orderType'],
        'returnFromCoupangMethod': value['returnFromCoupangMethod'],
        'packageStatus': value['packageStatus'],
        'remark': value['remark'],
        'adminRemark': value['adminRemark'],
        'blNo': value['blNo'],
        'requestType': value['requestType'],
        'packingStorage': value['packingStorage'],
        'listCtms': value['listCtms'],
        'warehouseRequest': value['warehouseRequest'],
        'goodsTotalQuantity': value['goodsTotalQuantity'],
        'goodsTotalAmount': value['goodsTotalAmount'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'enable': value['enable'],
        'deleteStatus': value['deleteStatus'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'prepayCouponId': value['prepayCouponId'],
        'wrongOrderReturn': value['wrongOrderReturn'],
        'orderWarehouseId': value['orderWarehouseId'],
        'requireBeforeAccept': value['requireBeforeAccept'],
        'currentWarehouseId': value['currentWarehouseId'],
        'ctmsType': value['ctmsType'],
        'returnOrderId': value['returnOrderId'],
        'coupangInboundCode': value['coupangInboundCode'],
        'goodsTotalAmountCny': value['goodsTotalAmountCny'],
        'coupangInboundDate': value['coupangInboundDate'],
        'coupangCompanyName': value['coupangCompanyName'],
        'buyType': value['buyType'],
        'returnMethod': value['returnMethod'],
        'returnFlagFile': value['returnFlagFile'],
        'splitOrderIds': value['splitOrderIds'],
    };
}

